<template>
  <main class="main page-inside faq-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big medium align-left">
            FAQ
          </div>
          <div class="content">
            <div class="checkout-step-list">
              <div class="checkout-step-list__item">
                <div class="items">
                  <div class="item" v-for="(item, index) in $parent.faq" :key="index">
                    <div class="title item__question">
                      <span class="number">{{ (index + 1).toString().padStart(2, '0') }}.</span> {{ item.question }}
                    </div>
                    <div v-html="item.answer" class="desc item__answer">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ContactForm/>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ContactForm from "@/components/ContactForm.vue";

export default {
  name: 'Faq',
  props: [],
  components: {
    ContactForm
  },
  data: function() {
    return {
      activePanels: []
    }
  },
  methods: {
   toggleAnswer(index) {
      if (this.isActiveAnswer(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1)
      } else {
        this.activePanels.push(index)
      }
    },
    isActiveAnswer(index) {
      return this.activePanels.includes(index)
    },
  }
}
</script>